import React, { useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
    DeleteCodManagementFn,
    getCodManagementFn,
} from "../../Services/CodManagement";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    IconButton,
} from "@mui/material";
import { toast } from "react-toastify";
import { Delete, Edit, Search } from "@mui/icons-material";
import AddCodManagement from "./AddCodprice";

const CodManagement = () => {
    const [initialValues, setInitailValues] = useState(null);
    const [search, setSearch] = useState("");

    const store_id = localStorage.getItem("store_id");

    const { data, refetch, isLoading } = useQuery(["cod-price", search], () =>
        getCodManagementFn({ store_id, search })
    );

    const { mutate: DeleteCod } = useMutation(DeleteCodManagementFn, {
        onSuccess: (res) => {
            if (res?.data?.response_code === 200) {
                toast.success(res?.data?.message);
                refetch();
            } else {
                toast.warn(res?.data?.message);
            }
        },
    });

    const filteredRows = data?.data?.data

    return (
        <div className="p-4 space-y-4">
            {/* Header row */}
            <div className="flex w-full justify-between items-center">
                {/* Search Box */}
                <div className="flex items-center border rounded-md px-2 bg-white">
                    <Search className="!text-gray-500" />
                    <TextField
                        variant="standard"
                        placeholder="Search COD Range"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        InputProps={{
                            disableUnderline: true,
                        }}
                        className="!ml-2 !w-48"
                    />
                </div>

                {/* Add COD Button */}
                <AddCodManagement
                    data={initialValues}
                    setInitailValues={setInitailValues}
                />
            </div>

            {/* Table */}
            <div className="item-center form h-[400px] w-full">
                <TableContainer
                    component={Paper}
                    sx={{ maxHeight: "70vh" }}
                    className="!bg-slate-50 !bg-opacity-95 shadow-md rounded-lg"
                >
                    <Table stickyHeader aria-label="sticky table" size="small">
                        <TableHead>
                            <TableRow>
                                {["SR NO.", "Min Amount", "Max Amount", "Action"].map(
                                    (head, idx) => (
                                        <TableCell
                                            key={idx}
                                            style={{
                                                borderRight: idx !== 3 ? "1px solid #D0D0D0" : "none",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                            className="!text-center !text-gray-800 !font-bold bg-gray-100"
                                        >
                                            {head}
                                        </TableCell>
                                    )
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isLoading ? (
                                <TableRow>
                                    <TableCell colSpan={4} className="text-center py-6">
                                        Loading COD Management...
                                    </TableCell>
                                </TableRow>
                            ) : filteredRows?.length > 0 ? (
                                filteredRows.map((row, ind) => (
                                    <TableRow key={row?.id}>
                                        <TableCell
                                            className="!text-center !text-[13px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {ind + 1}
                                        </TableCell>
                                        <TableCell
                                            className="!text-center !text-[13px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            ₹ {row?.min_amount}
                                        </TableCell>
                                        <TableCell
                                            className="!text-center !text-[13px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            ₹ {row?.max_amount}
                                        </TableCell>
                                        <TableCell className="!text-center !text-[13px]">
                                            <div className="flex items-center justify-center gap-3">
                                                <IconButton
                                                    size="small"
                                                    color="error"
                                                    onClick={() => DeleteCod({ cod_amount_id: row?.id, store_id })}
                                                >
                                                    <Delete fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                    size="small"
                                                    color="success"
                                                    onClick={() => setInitailValues(row)}
                                                >
                                                    <Edit fontSize="small" />
                                                </IconButton>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={4} className="text-center py-6">
                                        No COD price ranges found.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
};

export default CodManagement;
